import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import {
  userProfileReducer,
  UserProfileState,
} from './user-profile/user-profile.reducer';
import { environment } from '@env/environment';
import { authReducer, AuthState } from './auth/auth.reducer';
import { businessReducer, BusinessState } from './business/business.reducer';
import { cartReducer } from './cart/cart.reducer';
import { CartState } from './cart/cart.models';
import {
  appointmentReducer,
  AppointmentState,
} from './appointment/appointment.reducer';

export interface AppState {
  userProfile: UserProfileState;
  auth: AuthState;
  business: BusinessState;
  cart: CartState;
  appointment: AppointmentState;
}

export const reducers: ActionReducerMap<AppState> = {
  userProfile: userProfileReducer,
  auth: authReducer,
  business: businessReducer,
  cart: cartReducer,
  appointment: appointmentReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? []
  : [];
